import { HttpClientModule } from '@angular/common/http';
import { NgModule, PLATFORM_ID, SecurityContext } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { GraphQLModule } from '@challenger/care/modules/graphql/graphql.module';
import { LoadingIndicatorModule } from '@challenger6/vm-pattern-library/loading-indicator';
import { environment } from '../environments/environment';
import { AppConfigModule } from './app-config.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScullyLibModule } from '@scullyio/ng-lib';
import { VmGlobalConfigModule } from '@challenger6/vm-pattern-library/config/config.module';
import { MediaModule } from '@challenger6/vm-pattern-library/media/media.module';
import { VmThemeProviderModule } from '@virginmediao2/momentum-angular';
import { SmartFooterModule } from '@virginmediao2/momentum-angular/smart';
import { NgxsModule } from '@ngxs/store';
import { OAuthModule } from 'angular-oauth2-oidc';
import { HeaderWrapperModule } from '@challenger/care/components/header-wrapper/header-wrapper.module';
import { RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from './seo-flow/route-reuse-strategy.config';
import { MarkdownService, SECURITY_CONTEXT } from 'ngx-markdown';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { PageUrlsShellComponent } from './common/components/page-urls/page-urls-shell.component';
import { ModalModule } from '@challenger6/vm-pattern-library/modal/modal.module';
import { SessionService } from '@challenger/care/services/session.service';

const THIRD_PARTY_MODULES = [
  NgxsModule.forRoot([], {
    developmentMode: !environment.production,
    compatibility: {
      strictContentSecurityPolicy: true,
    },
  }),
  GraphQLModule,
  OAuthModule.forRoot(),
  ScullyLibModule.forRoot({
    useTransferState: true,
    alwaysMonitor: true,
  }),
  VmGlobalConfigModule.forRoot(environment),
];

const ANGULAR_MODULES = [
  CommonModule,
  BrowserModule,
  BrowserAnimationsModule,
  HttpClientModule,
  environment.plugins,
  BrowserModule.withServerTransition({ appId: 'vmHowtoApp' }),
];

const CUSTOM_MODULES = [
  LoadingIndicatorModule,
  AppConfigModule,
  AppRoutingModule,
  MediaModule,
  ModalModule,
  VmThemeProviderModule,
  SmartFooterModule,
  HeaderWrapperModule,
];

export const getWindow = (platformId: any): any => {
  return isPlatformBrowser(platformId) ? window : null;
};

@NgModule({
  declarations: [AppComponent, PageUrlsShellComponent],
  imports: [...ANGULAR_MODULES, ...THIRD_PARTY_MODULES, ...CUSTOM_MODULES],
  providers: [
    {
      provide: 'Window',
      useFactory: getWindow,
      deps: [PLATFORM_ID],
    },
    MarkdownService,
    {
      provide: SECURITY_CONTEXT,
      useValue: SecurityContext.HTML,
    },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    SessionService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
